import { Box } from '@chakra-ui/react';
import { type FC } from 'react';

import { MobileMainFilterPage } from '$/components/core/Collection/CollectionFilter/components/MobileFilter/MobileMainFilterPage';
import { MobileSubFilterPage } from '$/components/core/Collection/CollectionFilter/components/MobileFilter/MobileSubFilterPage';

interface Props {
  onClose: () => void;
  amount?: number;
  subFilter: string | null;
  setSubFilter: (subFiltername: string | null) => void;
}

export const MobileFilterDrawerContent: FC<Props> = ({
  onClose,
  amount,
  subFilter,
  setSubFilter,
}) => {
  return (
    <Box overflowY='auto' pb='8'>
      {!subFilter ? (
        <MobileMainFilterPage
          closeFilterDrawer={onClose}
          setSubFilter={setSubFilter}
          amount={amount}
        />
      ) : (
        <MobileSubFilterPage
          selectedSubFilter={subFilter}
          closeFilterDrawer={onClose}
          setSubFilter={setSubFilter}
        />
      )}
    </Box>
  );
};
